export const LOGO =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_campaign-profit-dash/artifacts/v77zuec5_refrevenue_logo.jpeg";
export const BRAND = "Ref Revenue";
